import { getNumberFormatter } from './numbers';

const getFormatter = (options: { currencySlug: string; locale?: string }) => {
  const currentLocale = options.locale ?? 'ru-RU';
  let formatter: Intl.NumberFormat;
  let isFallback: boolean;

  try {
    formatter = getNumberFormatter(currentLocale, {
      style: 'currency',
      currency: options.currencySlug.toUpperCase(),
      currencyDisplay: 'narrowSymbol',
    });
    isFallback = false;
  } catch {
    formatter = getNumberFormatter(currentLocale, {
      style: 'currency',
      currency: 'RUB',
      currencyDisplay: 'narrowSymbol',
    });
    isFallback = true;
  }

  return {
    formatter,
    isFallback,
  };
};

export const getPriceParts = ({
  locale,
  price,
  currencySlug,
}: {
  locale?: string;
  price: number;
  currencySlug: string;
}) => {
  const { formatter, isFallback } = getFormatter({ currencySlug, locale });

  const parts = formatter.formatToParts(price);

  const intPart =
    parts
      .filter((item) => item.type === 'integer')
      .map((item) => item.value)
      .join('') || '0';

  const fract = parts.find((item) => item.type === 'fraction')?.value || '0';

  let currency: string;
  if (isFallback) {
    currency = currencySlug;
  } else {
    currency = parts.find((item) => item.type === 'currency')?.value || currencySlug;
  }

  return {
    intPart,
    fract,
    currency,
  };
};
